<template>
    <div v-if="show" class="mask">
        <div class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">个人设置</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">姓名</div>
                        <div class="value"> <input class="ui-input full-width" type="text" v-model="formData.realname" /></div>
                    </div>
                </div>
                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">性别</div>
                        <RadioBoxList :data="option" v-model="formData.sex"  ></RadioBoxList>
                    </div>
                </div>

            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box">
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">取消</div>
                <div class="margin-left-s ui-yes-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>          
            </div>



        </div>
    </div>
</template>

<script>
    import {objToStr} from '@/utils/sysUtils'
    import RadioBoxList from '@/components/radioBoxList/RadioBoxList'
    

    export default {
        name:'SendUpdateModal',
        created() {
        },
        components:{RadioBoxList},
        props:{
            title:{},
            open:{}
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    this.formData.realname = sessionStorage.getItem('realname');
                    this.formData.sex = sessionStorage.getItem('sex');
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                show: null,

                formData:{
                    filterUser: true
                },
                option:[
                    {text:"男",value:"1"},
                    {text:"女",value:"0"}
                ],                
                userName : sessionStorage.getItem("realname"),
            }
        },
        methods:{
            confirm() {
                this.$emit("confirm", this.formData);

            },
            
            close() {
                this.$emit("close")
            },
             

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 30px;
    }
    .doc-edit-modal {
        width: 540px;
        height: 400px;
    }
    .edit-area {
       width: 500px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/UserEditModal.vue